"use client";
import { ReduxProvider } from "@/redux/provider";
import QuickViewModal from "@/components/Common/QuickViewModal";
import CartSidebarModal from "@/components/Common/CartSidebarModal";
import PreviewSliderModal from "@/components/Common/PreviewSlider";
import CartProvider from "@/components/Providers/CartProvider";
import { AutoOpenCartProvider } from "@/components/Providers/AutoOpenCartProvider";
import { ModalProvider } from "@/app/context/QuickViewModalContext";
import { PreviewSliderProvider } from "@/app/context/PreviewSliderContext";
import { handle401Action } from "@/lib/nexus-api";
import { useEffect, Suspense } from "react";
import { GclidTracker } from "@/components/GclidTracker/GclidTracker";

const Providers = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      if (response.status === 401) {
        handle401Action();
      }
      return response;
    };
  }, []);

  return (
    <ReduxProvider>
      <CartProvider>
        <AutoOpenCartProvider>
          <ModalProvider>
            <PreviewSliderProvider>
              <Suspense fallback={null}>
                <GclidTracker />
              </Suspense>
              {children}
              <CartSidebarModal />
              <PreviewSliderModal />
            </PreviewSliderProvider>
          </ModalProvider>
        </AutoOpenCartProvider>
      </CartProvider>
    </ReduxProvider>
  );
};

export default Providers;
